import { render } from "./Hero.vue?vue&type=template&id=774672b5"
const script = {}
script.render = render

export default script